export const CONTENT_TYPE_FILE = 'file';
export const BRAND_ASSET_FILE_TYPE = 'brand_asset';
export const CONTENT_APPROVAL_FILE_TYPE = 'content_approval';
export const CONTENT_APPROVAL_STATUS_NONE = '';
export const CONTENT_APPROVAL_STATUS_REVIEW = 'review';
export const CONTENT_APPROVAL_STATUS_REJECTED = 'rejected';
export const CONTENT_APPROVAL_STATUS_APPROVED = 'approved';
export const CONTENT_APPROVAL_STATUS_COMPLETED = 'completed';
export const CONTENT_APPROVAL_STATUS_LABELS = {
    [CONTENT_APPROVAL_STATUS_NONE]: 'Unsubmitted',
    [CONTENT_APPROVAL_STATUS_REVIEW]: 'In Review',
    [CONTENT_APPROVAL_STATUS_REJECTED]: 'Needs Changes',
    [CONTENT_APPROVAL_STATUS_APPROVED]: 'Approved',
    [CONTENT_APPROVAL_STATUS_COMPLETED]: 'Completed'
};
export const CONTENT_APPROVAL_STATUS_COLORS = {
    [CONTENT_APPROVAL_STATUS_NONE]: 'basic',
    [CONTENT_APPROVAL_STATUS_REVIEW]: 'primary',
    [CONTENT_APPROVAL_STATUS_REJECTED]: 'warning',
    [CONTENT_APPROVAL_STATUS_APPROVED]: 'good',
    [CONTENT_APPROVAL_STATUS_COMPLETED]: 'good'
};
export const CONTENT_APPROVAL_ERROR_MESSAGES = {
    [CONTENT_APPROVAL_STATUS_NONE]: 'Brand approval is required before you post.',
    [CONTENT_APPROVAL_STATUS_REVIEW]: 'An email notification will be sent to you once it\'s been approved.',
    [CONTENT_APPROVAL_STATUS_REJECTED]: 'has requested changes. Please complete these changes and resubmit your content for approval.',
    [CONTENT_APPROVAL_STATUS_APPROVED]: 'has approved your content. To complete this deliverable, please share your content on the agreed upon post date.',
    [CONTENT_APPROVAL_STATUS_COMPLETED]: 'Deliverable is complete.'
};
export const CONTENT_APPROVAL_STATUS_HEADERS = {
    [CONTENT_APPROVAL_STATUS_REVIEW]: 'Submitted for Approval',
    [CONTENT_APPROVAL_STATUS_REJECTED]: 'Submitted for Approval',
    [CONTENT_APPROVAL_STATUS_APPROVED]: 'Submitted for Approval',
    [CONTENT_APPROVAL_STATUS_COMPLETED]: 'Submitted for Approval'
};
export const ONBOARDING_STEP_CONTENT_APPROVAL_MADE_EASY = 'content-approval-made-easy';
export const ONBOARDING_STEP_SHOW_SHARE_YOUR_BEST_CONTENT = 'share-your-best-content';
export const CONTENT_APPROVAL_ONBOARDING_STEPS = {
    [ONBOARDING_STEP_CONTENT_APPROVAL_MADE_EASY]: {
        image: 'https://d38xvr37kwwhcm.cloudfront.net/image/influencer/content-approval-onboarding-1%402x.png',
        heading: 'Content approval made easy',
        subHeading: null,
        content: 'Strengthen your collaboration with Content Approval, a seamless way to partner on a post prior to it going live',
        ctaText: 'Next',
        showHelpDocs: false
    },
    [ONBOARDING_STEP_SHOW_SHARE_YOUR_BEST_CONTENT]: {
        image: 'https://d38xvr37kwwhcm.cloudfront.net/image/influencer/content-approval-onboarding-2%402x.png',
        heading: 'Share your best content',
        subHeading: 'How it works',
        content: [
            {
                title: 'Upload your deliverable',
                description: 'Include your content and caption, if applicable',
                icon: 'upload'
            },
            {
                title: 'Wait for the brand to review',
                description: 'They may request changes or approve it',
                icon: 'clipboard-list'
            },
            {
                title: 'Share it with your audience',
                description: 'Post your content to complete the task',
                icon: 'bullhorn'
            }
        ],
        ctaText: 'Got it!',
        showHelpDocs: true
    }
};
